import type { FC } from 'react';

interface BrandIconProps {
  name: string;
  className?: string;
}

const icons: Record<string, FC<{ className?: string }>> = {
  WhatsApp: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  ),
  Telegram: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#0088cc">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  ),
  Instagram: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="ig" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#feda75" />
          <stop offset="50%" stopColor="#d62976" />
          <stop offset="100%" stopColor="#4f5bd5" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig)" />
      <path d="M12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm0 8a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zM18 6.5a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z" fill="#fff" />
      <circle cx="12" cy="12" r="4.4" stroke="#fff" strokeWidth="1.6" fill="none" />
    </svg>
  ),
  X: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#000">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  Messenger: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#0084FF">
      <path d="M12 0C5.373 0 0 4.975 0 11.115c0 3.47 1.72 6.56 4.415 8.568V24l4.915-2.705c1.39.387 2.86.595 4.37.595 6.627 0 12-4.975 12-11.115S18.627 0 12 0zm6.15 8.63l-4.18 6.63c-.26.41-.74.57-1.16.38l-3.36-1.89a.68.68 0 0 0-.58-.04l-3.13.97a.67.67 0 0 1-.78-.91l4.18-6.63c.26-.41.74-.57 1.16-.38l3.36 1.89a.68.68 0 0 0 .58.04l3.13-.97a.67.67 0 0 1 .78.91z" />
    </svg>
  ),
  ZuriChat: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#2563eb">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <path d="M8 9l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  ),
  'Google Analytics': ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#E37400">
      <path d="M22.84 23.04l-6.96-12.14a1.5 1.5 0 0 0-2.6 0L8 18.2V1.5A1.5 1.5 0 0 0 6.5 0h-5A1.5 1.5 0 0 0 0 1.5v21A1.5 1.5 0 0 0 1.5 24h5c.42 0 .8-.17 1.07-.45l.02-.02a1.5 1.5 0 0 0 .41-1.03v-6.5l4.98 8.66a1.5 1.5 0 0 0 2.6 0l6.96-12.13a1.5 1.5 0 0 0-2.6-1.49z" />
    </svg>
  ),
  Gmail: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#EA4335">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  LiveChat: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#8b5cf6">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  ),
  Email: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#6366f1">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  Meta: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#1877F2">
      <rect width="24" height="24" rx="5" />
      <path d="M13.6 18v-6.2h2.1l.3-2.4H13.6V7.8c0-.7.2-1.2 1.2-1.2h1.3V4.5c-.6-.1-1.3-.1-1.9-.2-1.9 0-3.2 1.2-3.2 3.3v1.8H8.9v2.4h2.1V18h2.6z" fill="#fff" />
    </svg>
  ),
  GoogleCloud: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="gcp" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4285F4" />
          <stop offset="33%" stopColor="#EA4335" />
          <stop offset="66%" stopColor="#FBBC05" />
          <stop offset="100%" stopColor="#34A853" />
        </linearGradient>
      </defs>
      <path d="M12.2 4.6a7.4 7.4 0 0 0-6.9 4.7 1.5 1.5 0 0 0 .2 1.6l2.2 2.2c.3.3.7.3 1 0 .4-.3.4-.8.2-1.2a3.7 3.7 0 0 1 3.3-5.5 3.7 3.7 0 0 1 3.7 3.7 3.7 3.7 0 0 1-3.7 3.7H4.2c-.5 0-.9.4-.9.9v.1c0 .5.4.9.9.9h7.9a5.9 5.9 0 0 0 5.9-5.9 5.9 5.9 0 0 0-5.7-5.1z" fill="url(#gcp)" />
    </svg>
  ),
};

export default function BrandIcon({ name, className = 'h-8 w-8' }: BrandIconProps) {
  const Icon = icons[name] || icons.ZuriChat;
  return <Icon className={className} />;
}
